import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { RootState } from '../../../../../store/reducers/rootReducer'
import { IClientsItem } from '../../../../modules/API/Defaults/models/customers'
import SearchCustomers from '../../../../main/second/mainbar/forcasts/Supply/Components/SearchCustomers'

type Props = {
  customerID: number
  onCustomerChange: (id: number) => void 
}

const Wrapper = styled.div`
  width: 100%;
`

const CustomerSelector = ({ customerID, onCustomerChange }: Props) => {
  const clientList = useSelector(
    (state: RootState) => state.defaults.clientList.list
  ) as IClientsItem[] | null

  return (
    <SearchCustomers
      list={clientList ?? []}
      defaultID={customerID}
      setCustomerID={onCustomerChange}
      placeholder="בחר לקוח יעד"
      required
    />
  )
}

export default CustomerSelector
